import React from 'react'
import PropTypes from 'prop-types'
import loadInstanceSectionAction from 'modules/section/actions/index.js'
import { isDifferentLocationUtil } from 'modules/router/utils/index.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import getInstanceSectionSelector from 'modules/section/selectors/get-instance/index.js'
import { logUtil } from 'packages/src'
import { hasContentReduxUtil } from 'modules/redux/utils/hasContent/index.js'

const loadInstance = (Component) => {
  const LoadInstance = (props) => {
    const prevLocationRef = React.useRef()
    const instance = useSelector(state => getInstanceSectionSelector()(state, props))

    const loadData = (propsToUse = props) => {
      const debugProps = {
        instance,
        props
      }
      logUtil('LoadInstance#loadData').debug('debugProps=', debugProps)

      if (hasContentReduxUtil(instance)) {
        logUtil('LoadInstance#loadData').debug('instance already loaded, skipping load')
        return
      }

      logUtil('LoadInstance#loadData').debug('call loadInstanceSectionAction')
      propsToUse.dispatch(
        loadInstanceSectionAction({
          route: propsToUse.route,
          match: propsToUse.match
        })
      )
    }

    // Effect for initial load (equivalent to componentDidMount)
    React.useEffect(() => {
      loadData()
    }, []) // Empty dependency array means this runs once on mount

    // Effect for updates (equivalent to componentDidUpdate)
    React.useEffect(() => {
      if (
        prevLocationRef.current &&
        isDifferentLocationUtil(prevLocationRef.current, props.location) &&
        props.route.isInstance
      ) {
        loadData(props)
      }
      prevLocationRef.current = props.location
    }, [
      props.location,
      props.route
    ])

    return <Component {...props} />
  }

  LoadInstance.propTypes = {
    location: PropTypes.object.isRequired,
    match: PropTypes.object,
    route: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired
  }

  LoadInstance.displayName = `LoadInstance(${Component.displayName || Component.name})`

  return LoadInstance
}

export default loadInstance
